/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1444
 */

module.exports = function (e, t) {
  for (var n = -1, /* [auto-meaningful-name] */t$length = t.length, /* [auto-meaningful-name] */e$length = e.length; ++n < t$length;) {
    e[e$length + n] = t[n]
  }
  return e
}
